var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTrustmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_61",
    width: 108.658,
    height: 44,
    "data-name": "Group 61",
    viewBox: "0 0 108.658 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    d: "M0 0h8.362v12.607H0z",
    className: "cls-1",
    "data-name": "Clip 2",
    transform: "translate(.296 .301)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_5",
    d: "M0 0h12.545v8.363H0z",
    className: "cls-1",
    "data-name": "Clip 5",
    transform: "translate(.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_8",
    d: "M0 0h10.36v8.363H0z",
    className: "cls-1",
    "data-name": "Clip 8",
    transform: "translate(.298)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_11",
    d: "M0 0h8.362v10.36H0z",
    className: "cls-1",
    "data-name": "Clip 11",
    transform: "translate(.296)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_14",
    d: "M0 0h11.358v15.915H0z",
    className: "cls-1",
    "data-name": "Clip 14",
    transform: "translate(0 .478)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_43",
    d: "M0 44h108.658V0H0z",
    className: "cls-1",
    "data-name": "Clip 43"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-9{fill:#26265e}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(100 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-2",
    d: "M0 0h8.362v12.607H0z",
    className: "cls-1",
    "data-name": "Clip 2",
    transform: "translate(.296 .301)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    clipPath: "url(#clip-path)",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    fill: "#37b3e0",
    d: "M8.363 12.607V2A42.915 42.915 0 0 1 0 0a41.924 41.924 0 0 0 8.363 12.607",
    "data-name": "Fill 1",
    transform: "translate(.296 .301)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_5-2",
    d: "M0 0h12.545v8.363H0z",
    className: "cls-1",
    "data-name": "Clip 5",
    transform: "translate(.75)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-2",
    clipPath: "url(#clip-path-2)",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    fill: "#f9bb3c",
    d: "M0 0a42.42 42.42 0 0 0 12.545 8.363 41.787 41.787 0 0 1-2-8.363z",
    "data-name": "Fill 4",
    transform: "translate(.75)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_8-2",
    d: "M0 0h10.36v8.363H0z",
    className: "cls-1",
    "data-name": "Clip 8",
    transform: "translate(.298)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9-2",
    clipPath: "url(#clip-path-3)",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    fill: "#ea4327",
    d: "M2 8.363L10.36 0H0a42.843 42.843 0 0 0 2 8.363",
    "data-name": "Fill 7",
    transform: "translate(.298)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_11-2",
    d: "M0 0h8.362v10.36H0z",
    className: "cls-1",
    "data-name": "Clip 11",
    transform: "translate(.296)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12-2",
    clipPath: "url(#clip-path-4)",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    d: "M8.363 10.36V0L0 8.363a41.856 41.856 0 0 0 8.363 2",
    className: "cls-9",
    "data-name": "Fill 10",
    transform: "translate(.296)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_14-2",
    d: "M0 0h11.358v15.915H0z",
    className: "cls-1",
    "data-name": "Clip 14",
    transform: "translate(0 .478)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15-2",
    clipPath: "url(#clip-path-5)",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_13",
    d: "M4.494 2.247H0V0h11.359v2.247H6.866v13.668H4.494z",
    className: "cls-9",
    "data-name": "Fill 13",
    transform: "translate(-.001 .478)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_16",
    d: "M0 0h2.309v1.685A3.157 3.157 0 0 1 5.3 0h1.31v2.246H4.993c-1.873 0-2.621 1-2.621 3.246v5.367H0z",
    className: "cls-9",
    "data-name": "Fill 16",
    transform: "translate(10.922 20.534)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_18",
    d: "M0 6.3V0h2.372v6.116c0 1.81.874 2.933 2.621 2.933a2.78 2.78 0 0 0 2.746-3.058V0h2.309v10.86H7.739V9.424a4.082 4.082 0 0 1-3.308 1.622C1.56 11.046 0 9.3 0 6.3",
    className: "cls-9",
    "data-name": "Fill 18",
    transform: "translate(18.661 20.534)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_20",
    d: "M0 8.862L2.06 7.8a3.075 3.075 0 0 0 2.808 1.56c1.311 0 2-.686 2-1.436 0-.873-1.249-1.06-2.622-1.373C2.372 6.178.5 5.554.5 3.307.5 1.623 2.122 0 4.681 0A5 5 0 0 1 9.05 2.122l-1.935 1.06a2.871 2.871 0 0 0-2.434-1.248c-1.248 0-1.872.624-1.872 1.311 0 .811 1 1 2.559 1.373 1.81.375 3.807 1 3.807 3.246 0 1.5-1.311 3.494-4.369 3.494A5.088 5.088 0 0 1 0 8.862",
    className: "cls-9",
    "data-name": "Fill 20",
    transform: "translate(29.832 20.222)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_22",
    d: "M0 3.87h1.873V1.31L4.244 0v3.87h2.309v2.06H4.244v4.3c0 1.935.312 2.247 2.309 2.247v2.185h-.374c-3.308 0-4.306-1.062-4.306-4.432V5.867H0z",
    className: "cls-9",
    "data-name": "Fill 22",
    transform: "translate(39.881 16.664)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_24",
    d: "M0 .187h2.309V1.5A3.825 3.825 0 0 1 5.492 0 3.744 3.744 0 0 1 9.05 1.934 4.228 4.228 0 0 1 12.732 0c2.933 0 4.494 1.809 4.494 4.555v6.491h-2.372V4.68A2.382 2.382 0 0 0 12.357 2C10.922 2 9.8 2.995 9.8 4.93v6.116H7.427V4.555A2.3 2.3 0 0 0 4.993 2c-1.5 0-2.621 1-2.621 3v6.053H.062V.187z",
    className: "cls-9",
    "data-name": "Fill 24",
    transform: "translate(47.869 20.347)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_26",
    d: "M5.312 11.235A5.236 5.236 0 0 1 1.62 9.726 5.6 5.6 0 0 1 0 5.679a5.668 5.668 0 0 1 1.638-4.15A5.361 5.361 0 0 1 5.429 0a4.729 4.729 0 0 1 3.62 1.623V.187h2.31v10.86h-2.31v-1.5a4.542 4.542 0 0 1-3.62 1.685zm.429-9.113a3.427 3.427 0 0 0-3.432 3.495 3.459 3.459 0 0 0 3.432 3.558 3.42 3.42 0 0 0 3.433-3.558 3.388 3.388 0 0 0-3.433-3.495z",
    className: "cls-9",
    "data-name": "Fill 26",
    transform: "translate(66.531 20.284)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_28",
    d: "M0 0h2.309v1.685A3.158 3.158 0 0 1 5.3 0h1.316v2.246H4.993c-1.872 0-2.621 1-2.621 3.246v5.367H0z",
    className: "cls-9",
    "data-name": "Fill 28",
    transform: "translate(79.887 20.534)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_30",
    d: "M4.119 10.984l-1.81 2v2.806H0V0h2.309v10.36l4.869-5.367h2.808L5.742 9.611l4.368 6.241H7.489z",
    className: "cls-9",
    "data-name": "Fill 30",
    transform: "translate(87.626 15.541)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_32",
    d: "M2.059 5.992a1.883 1.883 0 0 1-1.622-.874v.811H0V0h.437v2.684a1.951 1.951 0 0 1 1.622-.937 2.046 2.046 0 0 1 2.06 2.123 2.094 2.094 0 0 1-2.06 2.122zm0-3.745a1.685 1.685 0 0 0 0 3.37 1.619 1.619 0 0 0 1.623-1.685 1.657 1.657 0 0 0-1.623-1.685z",
    className: "cls-9",
    "data-name": "Fill 32",
    transform: "translate(4.494 36.198)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_34",
    d: "M2.06 4.245A2.049 2.049 0 0 1 0 2.123 2.076 2.076 0 0 1 2.122 0a1.971 1.971 0 0 1 2.06 2.06v.188H.437a1.649 1.649 0 0 0 1.685 1.56 1.506 1.506 0 0 0 1.5-1L3.994 3A2.074 2.074 0 0 1 2.06 4.245zm0-3.87A1.66 1.66 0 0 0 .5 1.811h3.182A1.491 1.491 0 0 0 2.06.375z",
    className: "cls-9",
    "data-name": "Fill 34",
    transform: "translate(9.424 38.008)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_36",
    d: "M0 .062h.437v.749A1.611 1.611 0 0 1 1.935 0a1.721 1.721 0 0 1 1.81 1.872v2.247h-.437V1.872A1.3 1.3 0 0 0 1.935.437 1.413 1.413 0 0 0 .5 1.872v2.247H.062V.062z",
    className: "cls-9",
    "data-name": "Fill 36",
    transform: "translate(14.604 38.009)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_38",
    d: "M2.06 4.245A2.049 2.049 0 0 1 0 2.123 2.076 2.076 0 0 1 2.122 0a1.971 1.971 0 0 1 2.06 2.06v.188H.437a1.649 1.649 0 0 0 1.685 1.56 1.506 1.506 0 0 0 1.5-1L4 3a2.076 2.076 0 0 1-1.94 1.245zm0-3.87A1.737 1.737 0 0 0 .437 1.811h3.245A1.491 1.491 0 0 0 2.06.375z",
    className: "cls-9",
    "data-name": "Fill 38",
    transform: "translate(19.285 38.008)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_40",
    d: "M0 1.872h.687V1.5C.687.311 1 0 2.122 0h.062v.436c-.873 0-1.061.125-1.061 1.064v.374h1.061v.437H1.123v3.62H.687V2.309H0z",
    className: "cls-9",
    "data-name": "Fill 40",
    transform: "translate(23.904 36.199)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Clip_43-2",
    d: "M0 44h108.658V0H0z",
    className: "cls-1",
    "data-name": "Clip 43"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    clipPath: "url(#clip-path-6)",
    "data-name": "Mask Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_42",
    d: "M.437 5.867H0V1.81h.437v4.056zm0-4.681H0V0h.437v1.185z",
    className: "cls-9",
    "data-name": "Fill 42",
    transform: "translate(26.899 36.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_44",
    d: "M0 1.186h.687V.249L1.186 0v1.248h1v.437h-1v2.122c0 .874.187 1.062 1 1.062V5.3h-.064C1 5.3.687 4.994.687 3.807V1.623H0z",
    className: "cls-9",
    "data-name": "Fill 44",
    transform: "translate(28.085 36.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_45",
    d: "M0 3.495l.375-.312a1.538 1.538 0 0 0 1.248.624c.687 0 1.061-.374 1.061-.811 0-.5-.562-.624-1.186-.749C.874 2.059.187 1.873.187 1.124.187.5.749 0 1.623 0a1.727 1.727 0 0 1 1.436.624l-.375.312a1.371 1.371 0 0 0-1.123-.5c-.624 0-.936.312-.936.749 0 .5.561.624 1.123.748.624.188 1.373.375 1.373 1.124 0 .562-.437 1.186-1.5 1.186A2.116 2.116 0 0 1 0 3.495",
    className: "cls-9",
    "data-name": "Fill 45",
    transform: "translate(30.893 37.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_46",
    d: "M2.06 5.992a2.059 2.059 0 0 1-1.623-.874v.811H0V0h.437v2.684a1.951 1.951 0 0 1 1.623-.937A2.046 2.046 0 0 1 4.12 3.87a2.094 2.094 0 0 1-2.06 2.122zm0-3.745a1.685 1.685 0 0 0 0 3.37 1.619 1.619 0 0 0 1.623-1.685A1.657 1.657 0 0 0 2.06 2.247z",
    className: "cls-9",
    "data-name": "Fill 46",
    transform: "translate(37.072 36.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_47",
    d: "M2.06 4.245A2.1 2.1 0 0 1 0 2.123 2.077 2.077 0 0 1 2.123 0a1.971 1.971 0 0 1 2.059 2.06v.188H.438a1.65 1.65 0 0 0 1.685 1.56 1.5 1.5 0 0 0 1.5-1L4 3a2.074 2.074 0 0 1-1.94 1.245zm.063-3.87A1.668 1.668 0 0 0 .5 1.811h3.245A1.491 1.491 0 0 0 2.123.375z",
    className: "cls-9",
    "data-name": "Fill 47",
    transform: "translate(42.002 38.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_48",
    d: "M1.81 3.808L0 0h.5L2 3.308 3.433 0h.561L1.373 5.929h-.5z",
    className: "cls-9",
    "data-name": "Fill 48",
    transform: "translate(46.559 38.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_49",
    d: "M2.122 4.244A2.1 2.1 0 0 1 0 2.122 2.1 2.1 0 0 1 2.122 0a2.1 2.1 0 0 1 2.123 2.122 2.1 2.1 0 0 1-2.123 2.122zm0-3.807A1.656 1.656 0 0 0 .5 2.122a1.657 1.657 0 0 0 1.622 1.686 1.657 1.657 0 0 0 1.623-1.686A1.657 1.657 0 0 0 2.122.437z",
    className: "cls-9",
    "data-name": "Fill 49",
    transform: "translate(50.927 38.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_50",
    d: "M0 .062h.437v.749A1.611 1.611 0 0 1 1.935 0a1.721 1.721 0 0 1 1.81 1.872v2.247h-.437V1.872A1.3 1.3 0 0 0 1.935.437 1.412 1.412 0 0 0 .5 1.872v2.247H.062V.062z",
    className: "cls-9",
    "data-name": "Fill 50",
    transform: "translate(56.108 38.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_51",
    d: "M2.059 6.054A2.241 2.241 0 0 1 0 3.869a2.046 2.046 0 0 1 2.059-2.122 1.816 1.816 0 0 1 1.624.936V0h.437v5.929h-.437v-.812a1.957 1.957 0 0 1-1.624.937zm0-3.87A1.618 1.618 0 0 0 .437 3.869a1.654 1.654 0 1 0 3.308 0 1.687 1.687 0 0 0-1.686-1.685z",
    className: "cls-9",
    "data-name": "Fill 51",
    transform: "translate(60.789 36.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_52",
    d: "M2.059 5.992a1.946 1.946 0 0 1-1.622-.874v.811H0V0h.437v2.684a1.951 1.951 0 0 1 1.622-.937 2.046 2.046 0 0 1 2.06 2.123 2.094 2.094 0 0 1-2.06 2.122zm0-3.745a1.685 1.685 0 0 0 0 3.37 1.619 1.619 0 0 0 1.623-1.685 1.657 1.657 0 0 0-1.623-1.685z",
    className: "cls-9",
    "data-name": "Fill 52",
    transform: "translate(68.153 36.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_53",
    d: "M2.06 4.245A2.049 2.049 0 0 1 0 2.123 2.076 2.076 0 0 1 2.122 0a1.971 1.971 0 0 1 2.06 2.06v.188H.437a1.649 1.649 0 0 0 1.685 1.56 1.506 1.506 0 0 0 1.5-1L3.994 3A2.074 2.074 0 0 1 2.06 4.245zm.062-3.87A1.67 1.67 0 0 0 .5 1.811h3.245A1.492 1.492 0 0 0 2.122.375z",
    className: "cls-9",
    "data-name": "Fill 53",
    transform: "translate(73.084 38.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_54",
    d: "M0 .062h.437v.749A1.611 1.611 0 0 1 1.935 0a1.721 1.721 0 0 1 1.81 1.872v2.247h-.437V1.872A1.3 1.3 0 0 0 1.935.437 1.412 1.412 0 0 0 .5 1.872v2.247H.062V.062z",
    className: "cls-9",
    "data-name": "Fill 54",
    transform: "translate(78.264 38.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_55",
    d: "M2.06 4.245A2.049 2.049 0 0 1 0 2.123 2.076 2.076 0 0 1 2.122 0a1.971 1.971 0 0 1 2.06 2.06v.188H.437a1.649 1.649 0 0 0 1.685 1.56 1.506 1.506 0 0 0 1.5-1L3.994 3A2.074 2.074 0 0 1 2.06 4.245zm0-3.87A1.737 1.737 0 0 0 .437 1.811h3.245A1.491 1.491 0 0 0 2.06.375z",
    className: "cls-9",
    "data-name": "Fill 55",
    transform: "translate(82.945 38.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_56",
    d: "M0 1.872h.687V1.5C.687.311 1 0 2.122 0h.062v.436c-.873 0-1.061.125-1.061 1.064v.374h1.061v.437H1.123v3.62H.687V2.309H0z",
    className: "cls-9",
    "data-name": "Fill 56",
    transform: "translate(87.563 36.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_57",
    d: "M.437 5.867H0V1.81h.437v4.056zm0-4.681H0V0h.437v1.185z",
    className: "cls-9",
    "data-name": "Fill 57",
    transform: "translate(90.559 36.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_58",
    d: "M0 1.186h.687V.249L1.186 0v1.248h1v.437h-1v2.122c0 .874.187 1.062 1 1.062V5.3h-.064C1 5.3.687 4.994.687 3.807V1.623H0z",
    className: "cls-9",
    "data-name": "Fill 58",
    transform: "translate(91.807 36.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_59",
    d: "M0 3.495l.375-.312a1.535 1.535 0 0 0 1.248.624c.687 0 1.061-.374 1.061-.811 0-.5-.562-.624-1.186-.749C.874 2.059.187 1.873.187 1.124.187.5.749 0 1.623 0a1.727 1.727 0 0 1 1.436.624l-.375.312a1.37 1.37 0 0 0-1.123-.5c-.624 0-.937.312-.937.749 0 .5.562.624 1.124.748.624.188 1.373.375 1.373 1.124 0 .562-.437 1.186-1.5 1.186A2.116 2.116 0 0 1 0 3.495",
    className: "cls-9",
    "data-name": "Fill 59",
    transform: "translate(94.553 37.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_60",
    d: "M.811 1.622A.822.822 0 0 1 0 .811.822.822 0 0 1 .811 0a.822.822 0 0 1 .811.811.822.822 0 0 1-.811.811zm0-1.435a.624.624 0 1 0 .626.624.591.591 0 0 0-.626-.624zm-.125 1H.5V.374h.374a.285.285 0 0 1 .312.249.229.229 0 0 1-.25.249l.186.312H.936L.686.748h.125C.936.748 1 .748 1 .624S.936.5.811.5H.686V1.186z",
    className: "cls-9",
    "data-name": "Fill 60",
    transform: "translate(98.173 20.534)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTrustmark);
export default __webpack_public_path__ + "static/media/logo-trustmark.34d74b6b3614e54e9bb1536c7cbbef9b.svg";
export { ForwardRef as ReactComponent };